import Vue from 'vue'
import PhpDateTime from '../Helpers/PhpDateTime'


let formatiranDatumFunc = (
  podatek = new Date(),
  prikaziCas = false,
  krajsaOblika = false
) => {
  if (podatek === null) {
    return 'neznan'
  }
  if (krajsaOblika) {
    let danes = new Date()
    if (PhpDateTime.Format(podatek, 'Y-m-d') === PhpDateTime.Format(danes, 'Y-m-d')) {
      return PhpDateTime.Format(podatek, 'H:i')
    } else {
      if (podatek.getFullYear() === danes.getFullYear()) {
        return PhpDateTime.Format(podatek, 'd.m.Y')
      } else {
        return podatek.getFullYear()
      }
    }
  }

  return PhpDateTime.Format(podatek, prikaziCas ? 'd.m.Y H:i:s' : 'd.m.Y')
}

Vue.filter('formatiranDatumFromDate', formatiranDatumFunc)

Vue.filter(
  'formatiranDatumFromString',
  (datumString = '', prikaziCas = false, krajsaOblika = false) => {
    let podatek = new Date(datumString)
    if (datumString !== '') {
      let tmpDate = new Date(datumString)
      if (!isNaN(tmpDate.valueOf())) {
        podatek = tmpDate
      }
    }

    return formatiranDatumFunc(podatek, prikaziCas, krajsaOblika)
  }
)



// WEBPACK FOOTER //
// ./src/assets/js/Filters/dateFilters.js